import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose } from "./style";
import ProductionOrderSapExtraInfo from "../productionOrderSapExtraInfoForm";
import * as OrderSapServices from "../../../../services/ProductionOrderSapService";
import showDialog from "../../../utils/ShowDialog/ShowDialog";

export const useProductionOrderSapExtraInfo = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const onActionSuccess = async () => {
    if (refresh) {
      refresh();
    }
    handlerClosePopup("ModalForm");
  };

  const addExtraInfo = async (
    productionOrderSapUuid = undefined,
    data = undefined
  ) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <ProductionOrderSapExtraInfo
                  uuid={productionOrderSapUuid}
                  data={data}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => onActionSuccess()}
                ></ProductionOrderSapExtraInfo>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  const notify = (uuid) => {
    const okAction = async () => {
      try {
        const result = await OrderSapServices.notify(uuid);
        if (result) {
          if (refresh) {
            refresh();
          }
        }
      } catch (error) {}
    };

    const cancelAction = () => {};

    showDialog(
      t("forms.productionOrderSap.dialog.notify.title"),
      t("forms.productionOrderSap.dialog.notify.text"),
      "question",
      true,
      t("forms.productionOrderSap.dialog.notify.buttonOk"),
      false,
      okAction,
      t("forms.productionOrderSap.dialog.notify.buttonNo"),
      cancelAction
    );
  };

  return {
    addExtraInfo,
    notify,
  };
};
